export const translations = {
	nav: {
		title: 'Navegació',
		app: 'Certificat de donació',
	},
	footer: {
		poweredBy: 'Fet per',
		copyright: '© {{year}} WorldCoo. Tots els drets reservats.',
		termsAndConditions: 'Termes i condicions',
		privacyPolicy: 'Política de privadesa',
	},
	categories: {
		basicNeeds: 'Aigua i Energia',
		humanRights: 'Drets Humans',
		education: 'Educació',
		emergency: 'Emergències',
		feeding: 'Fam i Seguretat Alimentària',
		environment: 'Medi Ambient',
		habitat: 'Habitatge i Pobresa',
		health: 'Salut',
	},
	statistics: {
		campaigns: 'Campanyes',
		donations: 'Donacions',
		collected: 'Recaptat',
		collectedFromBudget: 'Objectiu de {{budget}}',
	},
	filters: {
		year: 'Any',
		state: 'Estat',
		cause: 'Causa',
		active: 'Activa',
		finished: 'Finalitzada',
		default: 'Per defecte',
		toggle: 'Alternar {{value}}',
	},
	actions: {
		close: 'Tancar',
		search: 'Cerca qualsevol cosa',
		filter: 'Filtrar',
		viewCampaign: 'Veure campanya',
		makeDonation: 'Fer donació',
		donate: 'Donar',
		selectLanguage: 'Seleccionar idioma',
		backToHome: "Tornar a l'inici",
		funded: 'Finançat',
		clear: 'Netejar Filtres',
		apply: 'Aplicar',
		goBack: 'Tornar',
		previous: 'Anterior',
		next: 'Següent',
	},
	portal: {
		heroButton: 'Comença a donar',
		campaigns: {
			title: 'Campanyes',
			description: "Explora les nostres iniciatives i tria la causa que més t'inspiri",
			notFound: 'No hi ha campanyes',
		},
		campaignFunded: 'Campanya finançada',
		percentageFunded: '{{percentage}}% Finançada',
		aCampaignFrom: 'Una campanya de: {{ngoName}}',
		beneficiaries: 'Beneficiaris',
		directBeneficiaries: '{{count}} directes',
		indirectBeneficiaries: '{{count}} indirectes',
		sdgs: {
			title: 'Objectius de Desenvolupament Sostenible',
			1: 'Fi de la Pobresa',
			2: 'Fam Zero',
			3: 'Salut i Benestar',
			4: 'Educació de Qualitat',
			5: 'Igualtat de Gènere',
			6: 'Aigua Neta i Sanejament',
			7: 'Energia Assequible i No Contaminant',
			8: 'Treball Decent i Creixement Econòmic',
			9: 'Indústria, Innovació i Infraestructura',
			10: 'Reducció de les Desigualtats',
			11: 'Ciutats i Comunitats Sostenibles',
			12: 'Producció i Consum Responsables',
			13: 'Acció pel Clima',
			14: 'Vida Submarina',
			15: "Vida d'Ecosistemes Terrestres",
			16: 'Pau, Justícia i Institucions Sòlides',
			17: 'Aliances per Assolir els Objectius',
		},
	},
	faq: {
		title: 'Preguntes freqüents',
		description: 'Respostes als dubtes més comuns dels nostres donants.',
	},
	campaign: {
		objectives: 'Objectius de la campanya',
		description: 'Descripció',
		activities: 'Activitats',
		beneficiaries: "Qui se'n beneficiarà?",
		updatesAndLinks: 'Més informació i enllaços',
		from: 'Des de:',
		until: 'Fins:',
	},
	campaigns: {
		notTranslated: 'Aquest projecte encara no està disponible en el teu idioma.',
	},
	placeholders: {
		amount: 'Una altra quantitat',
	},
	donate: {
		title: 'Fes la teva donació',
		details: {
			title: 'Afegeix les teves dades per continuar',
			subtitle:
				'Completa les teves dades per finalitzar la teva donació. També pots sol·licitar el teu certificat fiscal aquí.',
		},
		certificate: {
			title: 'Recupera fins a {{amount}}',
			subtitle: 'Certifica la teva donació amb un clic i automàticament apareixerà al teu esborrany de la Renda.',
		},
	},
	errors: {
		required: 'Aquest camp és obligatori',
		invalidExtref: 'El codi no és vàlid, ha de seguir aquest format: {{format}}',
		email: 'L’adreça de correu electrònic està mal formatada.',
		emailAlreadyExists: 'Aquest correu electrònic ja està en ús.',
		password: 'La teva contrasenya ha de tenir 6 caràcters o més.',
		confirmationCode: 'Si us plau, introdueix el codi de confirmació.',
		documentType: 'Tipus de document no vàlid',
		termsAndConditions: 'Has d’acceptar els termes i condicions',
		amount: 'Si us plau, selecciona o introdueix una quantitat vàlida.',
		signIn: 'Error a l’iniciar sessió',
		emailsDoNotMatch: 'Les adreces de correu electrònic no coincideixen.',
		passwordsDoNotMatch: 'Les contrasenyes no coincideixen.',
		imageFormat: 'Si us plau, deixa anar un fitxer d’imatge',
		camera: 'No es pot accedir a la càmera. Si us plau, assegura’t d’haver donat permís.',
		expiredCode: 'El codi ha caducat.',
		codeMismatch: 'El codi és incorrecte. Si us plau, torna-ho a intentar.',
		notAuthorized: 'Credencials incorrectes. Si us plau, torna-ho a intentar.',
		userDoesNotExist: 'L’usuari no existeix.',
		userNotConfirmed: 'Usuari no confirmat. Si us plau, confirma primer la teva adreça de correu electrònic.',
		userAlreadyConfirmed: 'L’usuari ja ha estat confirmat.',
		documentNumberExists: 'El número de document ja està en ús.',
		limitExceeded: 'Has arribat al límit d’intents. Si us plau, torna-ho a intentar més tard.',
		invalidPassword: 'La contrasenya no és vàlida, ha de tenir almenys 6 caràcters i no pot contenir espais.',
		captchaFailed: 'La verificació CAPTCHA ha fallat. Si us plau, torna-ho a intentar.',
		internal: 'Ho sentim, hi ha hagut un problema, el nostre equip ja ha estat informat, torna-ho a intentar més tard.',
	},
	documentTypes: {
		id: 'DNI',
		passport: 'Passaport',
		taxId: 'Identificació fiscal',
		nie: 'NIE',
		others: 'Altres',
	},
	labels: {
		code: 'Codi',
		email: 'Correu electrònic',
		repeatEmail: 'Repeteix el teu correu electrònic',
		password: 'Contrasenya',
		confirmPassword: 'Confirmar contrasenya',
		amount: 'Quantitat de donació',
		documentType: 'Tipus de document',
		documentNumber: 'Número de document',
		name: 'Nom',
		lastName: 'Cognom',
		streetName: 'Nom del carrer',
		streetNumber: 'Número',
		additionalInfo: 'Informació addicional',
		postalCode: 'Codi postal',
		city: 'Ciutat',
		country: 'País',
		region: 'Regió',
		province: 'Província',
		certificate: 'Vull rebre un certificat fiscal',
		termsAndConditions1:
			'Aquesta informació només es compartirà amb les organitzacions receptores de les teves donacions amb la finalitat de generar el corresponent certificat fiscal. Llegeix els ',
		termsAndConditions2: 'termes i condicions',
		language: 'Idioma',
	},
	checkout: {
		title: 'Mètode de pagament',
	},
	recaptcha: {
		description: 'protegit per reCAPTCHA.',
		privacy: 'Privacitat',
		terms: 'Termes',
	},
	thanks: {
		title: 'Gràcies\n per la teva donació!',
		description:
			'En breu rebràs un correu de confirmació amb tots els detalls. Junts estem construint un futur millor!',
	},
	termsAndConditions: {
		title: 'Termes de Protecció de dades',
		labelText: 'He llegit, entenc i accepto els termes de ',
		labelLink: 'Protecció de Dades de {{name}}',
		accept: 'He llegit, entenc i accepto',
		responsible: {
			title: 'Responsable',
			description: 'WORLDCOO S.L.',
		},
		purpose: {
			title: 'Finalitat',
			description:
				"Gestionar la relació comercial en tots els seus àmbits, així com la seva donació i la seva sol·licitud de certificat, i l'enviament de comunicacions comercials per via electrònica.",
			descriptionNgo:
				"La captació de fons per a projectes de l'ONG, mantenir-lo informat sobre l'ONG i l'evolució del projecte per al qual ha donat fons i l'emissió de certificats de desgravació fiscal.",
		},
		legitimacy: {
			title: 'Legitimació',
			description: "La base legal per al tractament de les seves dades és l'obtenció del seu consentiment.",
		},
		recipients: {
			title: 'Destinataris',
			description: 'No es cediran dades a tercers excepte que existeixi obligació legal per fer-ho.',
		},
		rights: {
			title: 'Drets',
			description:
				"Té dret a accedir, rectificar i suprimir les dades, així com altres drets, com s'explica a la informació addicional.",
		},
		additionalInfo: {
			title: 'Informació addicional',
			description:
				'Pot consultar informació addicional i detallada sobre Protecció de Dades a la nostra pàgina <a href="https://www.worldcoo.com/gdpr">web</a> o bé contactant a <a href="mailto:rgpd@worldcoo.com">rgpd@worldcoo.com</a>.',
			descriptionNgo:
				'Pot consultar informació addicional i detallada sobre Protecció de Dades al web de cada ONG.\n\n<b>{{ngoName}}</b>',
		},
	},
};
